import React from "react";

export const EmptyStateIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="143"
      height="148"
      fill="none"
      viewBox="0 0 143 148"
    >
      <path
        fill="#F1F5F9"
        stroke="#CBD5E1"
        d="M71.224.5c34.514 0 62.5 27.755 62.5 62s-27.986 62-62.5 62-62.5-27.754-62.5-62S36.71.5 71.224.5Z"
      ></path>
      <path
        fill="#F1F5F9"
        stroke="#CBD5E1"
        d="M71.224.5c34.514 0 62.5 27.755 62.5 62s-27.986 62-62.5 62-62.5-27.754-62.5-62S36.71.5 71.224.5Z"
      ></path>
      <path
        fill="#989FB0"
        d="M88.315 64.682H54.134a.706.706 0 0 1-.71-.71v-.945c0-.394.316-.71.71-.71h34.18c.394 0 .71.316.71.71v.946c0 .394-.316.71-.71.71"
      ></path>
      <g filter="url(#filter0_d_1196_34592)">
        <path
          fill="#fff"
          d="M120.447 17.551v91.898c0 2.68-2.205 4.886-4.883 4.886H26.883c-2.678 0-4.883-2.206-4.883-4.886V17.551c0-2.68 2.205-4.886 4.883-4.886h88.681c2.678 0 4.883 2.206 4.883 4.886"
        ></path>
      </g>
      <path
        fill="#CBD5E1"
        d="M120.447 17.551v3.547H22V17.55c0-2.68 2.205-4.886 4.883-4.886h88.681c2.678 0 4.883 2.206 4.883 4.886"
      ></path>
      <path
        fill="#EAEEF9"
        d="M27.119 18.418a1.497 1.497 0 1 0-.001-2.994 1.497 1.497 0 0 0 .001 2.994"
      ></path>
      <path
        fill="#EAEEF9"
        d="M31.766 18.418a1.497 1.497 0 1 0-.001-2.994 1.497 1.497 0 0 0 0 2.994"
        opacity="0.6"
      ></path>
      <path
        fill="#EAEEF9"
        d="M36.492 18.418a1.497 1.497 0 1 0-.002-2.994 1.497 1.497 0 0 0 .002 2.994"
        opacity="0.4"
      ></path>
      <path
        fill="#C2C8D6"
        d="M36.44 90.242c-.333-.087-.57-.387-.52-.73.024-.391.369-.659.757-.637.767.081 1.507.115 2.283.16a.665.665 0 0 1 .64.722.67.67 0 0 1-.72.645c-.777-.044-1.554-.088-2.357-.178-.047.027-.047.027-.084.018m17.084 3.225-.037-.01q-1.133-.415-2.237-.94c-.35-.17-.474-.6-.303-.952a.7.7 0 0 1 .947-.308q.993.496 2.016.882c.359.134.576.508.443.87-.097.371-.46.554-.83.458m-10.556-3.03a.654.654 0 0 1-.501-.647c-.014-.4.267-.724.665-.74.76-.04 1.528-.117 2.27-.24a.683.683 0 0 1 .788.602.69.69 0 0 1-.602.795c-.741.124-1.547.192-2.39.25-.12.008-.193-.01-.23-.02m14.681 3.828a.73.73 0 0 1-.528-.693c.023-.39.341-.705.73-.683.74.034 1.461-.015 2.193-.102.37-.062.728.23.789.602.06.373-.231.734-.602.796-.815.105-1.611.135-2.434.119zm-9.73-4.085a.7.7 0 0 1-.275-.15 14 14 0 0 1-1.682-1.71.73.73 0 0 1 .058-.976.72.72 0 0 1 .97.055 19 19 0 0 0 1.554 1.595c.284.272.335.683.063.969-.142.24-.429.285-.687.217m16.118 2.854c-.184-.048-.386-.18-.448-.394a.73.73 0 0 1 .362-.937c.67-.302 1.35-.64 1.964-1.036a.71.71 0 0 1 .97.213c.19.328.12.746-.216.976-.662.422-1.397.826-2.15 1.145a.73.73 0 0 1-.482.033M49.366 89.17c-.22-.058-.376-.218-.475-.442-.144-.355.046-.782.39-.89.706-.292 1.376-.594 1.981-.952a.71.71 0 0 1 .96.25.723.723 0 0 1-.253.966c-.689.376-1.415.743-2.205 1.052a.73.73 0 0 1-.398.016m-5.427-4.114a.75.75 0 0 1-.459-.358 24 24 0 0 1-.954-2.233c-.143-.355.084-.772.427-.88.344-.11.767.08.874.426.25.7.548 1.373.882 2.055.19.328.037.764-.289.957a.93.93 0 0 1-.481.033m10.762.426c-.11-.03-.174-.085-.275-.151a.66.66 0 0 1-.063-.97q.69-.831 1.298-1.803c.208-.343.625-.433.965-.225s.427.627.22.97a15 15 0 0 1-1.43 2.008.75.75 0 0 1-.715.17m14.628 3.735a.7.7 0 0 1-.276-.151.75.75 0 0 1-.053-1.006c.497-.545.966-1.137 1.362-1.748.198-.306.652-.386.955-.187.303.198.38.654.183.96a20 20 0 0 1-1.484 1.914c-.179.232-.43.285-.687.218M42.273 78.748a.654.654 0 0 1-.5-.647q-.028-1.257.167-2.456a.69.69 0 1 1 1.367.198c-.11.725-.147 1.47-.137 2.186a.72.72 0 0 1-.897.719m30.441 4.883-.073-.019a.69.69 0 0 1-.397-.897c.258-.687.489-1.42.673-2.126a.686.686 0 1 1 1.328.346 26 26 0 0 1-.721 2.312c-.115.288-.478.47-.81.384m-14.994-3.99c-.369-.096-.596-.433-.499-.804l.029-.112c.184-.706.285-1.394.339-2.054a.67.67 0 0 1 .72-.646.665.665 0 0 1 .639.723 11.7 11.7 0 0 1-.38 2.36c-.097.372-.479.63-.848.534m-13.708-7.106a.7.7 0 0 1-.24-.142.706.706 0 0 1-.099-.978 7.7 7.7 0 0 1 1.861-1.697.71.71 0 0 1 .97.213c.19.327.12.746-.216.975a5.8 5.8 0 0 0-1.552 1.421.74.74 0 0 1-.724.208m13.237.754a.61.61 0 0 1-.42-.348 5.4 5.4 0 0 0-1.314-1.612.66.66 0 0 1-.062-.969.65.65 0 0 1 .962-.066 7.2 7.2 0 0 1 1.605 2.005.69.69 0 0 1-.29.957c-.139.082-.333.072-.48.033m16.864 3.922c-.332-.087-.532-.377-.519-.73.037-.745.083-1.527.036-2.253a.72.72 0 0 1 .666-.74.714.714 0 0 1 .732.668c.027.8.018 1.592-.038 2.41-.023.391-.368.658-.756.636-.047.028-.084.018-.12.009m-24.425-7.56c-.295-.077-.504-.33-.51-.61-.024-.363.267-.724.628-.748a10.7 10.7 0 0 1 2.497.095c.378.06.633.443.573.824s-.442.639-.821.58c-.72-.109-1.413-.17-2.145-.084-.064-.056-.148-.038-.221-.057m24.003 1.021a.68.68 0 0 1-.493-.525 16.4 16.4 0 0 0-.613-2.184c-.097-.382.083-.772.464-.87.38-.1.766.08.864.463.24.737.425 1.54.61 2.341.06.373-.157.753-.527.815a1 1 0 0 1-.305-.04M31.064 89.554a.7.7 0 0 1-.51-.767.69.69 0 0 1 .785-.59q.568.09 1.135.177a.69.69 0 0 1 .583.787.69.69 0 0 1-.784.59c-.379-.06-.794-.128-1.173-.187zM27.284 88.62a.7.7 0 0 1-.453-.803.69.69 0 0 1 .825-.53l1.12.257a.69.69 0 0 1 .524.827.69.69 0 0 1-.824.531c-.373-.086-.783-.184-1.156-.27zM23.488 87.502a.7.7 0 0 1-.413-.823.69.69 0 0 1 .848-.491l1.107.312a.69.69 0 0 1 .484.85.69.69 0 0 1-.849.492c-.368-.104-.773-.222-1.141-.326zM71.378 64.435c-.185-.049-.313-.161-.431-.311-.19-.328-.381-.655-.581-.945-.228-.337-.121-.746.178-.986.335-.23.741-.124.978.176.227.337.455.674.635 1.039a.723.723 0 0 1-.251.966c-.177.073-.38.1-.528.06"
      ></path>
      <ellipse
        cx="69.784"
        cy="61.054"
        fill="#989FB0"
        rx="1.299"
        ry="2.166"
        transform="rotate(-37.972 69.784 61.054)"
      ></ellipse>
      <path
        stroke="#737886"
        strokeLinecap="round"
        strokeWidth="0.371"
        d="M72.316 63.996a2.42 2.42 0 0 1-.359 1.529l-.061.098M71.303 64.41a2.42 2.42 0 0 1-.438 1.508l-.067.095"
      ></path>
      <ellipse
        cx="71.574"
        cy="63.626"
        fill="#989FB0"
        rx="1.299"
        ry="2.783"
        transform="rotate(-114.17 71.574 63.626)"
      ></ellipse>
      <ellipse
        cx="73.478"
        cy="62.037"
        fill="#737886"
        rx="0.475"
        ry="0.237"
        transform="rotate(17.607 73.478 62.037)"
      ></ellipse>
      <ellipse
        cx="71.776"
        cy="61.107"
        fill="#B6BFCC"
        rx="1.403"
        ry="2.338"
        transform="rotate(-5.51 71.776 61.107)"
      ></ellipse>
      <path
        fill="url(#paint0_linear_1196_34592)"
        d="m101.581 86.855-9.562-9.735c-.981-.998-2.39-1.373-3.678-1.123l-2.33-2.371c6.62-8.362 6.069-20.655-1.532-28.393-6.375-6.49-15.876-7.925-23.599-4.243-2.145.998-4.168 2.433-6.007 4.243-2.268 2.247-3.862 4.93-4.842 7.8-.49 1.373-.858 2.746-1.042 4.181-.92 6.428 1.042 13.23 5.884 18.16l.307.311c4.045 3.994 9.255 5.928 14.527 5.928 4.658 0 9.317-1.56 13.117-4.68l2.33 2.371c-.246 1.31.122 2.746 1.103 3.745l9.5 9.734a4.02 4.02 0 0 0 5.763 0c1.655-1.622 1.655-4.306.061-5.928m-20.105-14.54c-.736.75-1.533 1.373-2.33 1.997-.796.562-1.593.999-2.39 1.373a16.27 16.27 0 0 1-14.037 0 16.5 16.5 0 0 1-4.72-3.37c-4.045-4.118-5.578-9.797-4.597-15.1.245-1.436.674-2.871 1.349-4.182a17.3 17.3 0 0 1 3.248-4.68c.92-.936 1.9-1.747 2.942-2.371 2.697-1.747 5.762-2.559 8.827-2.559 4.29 0 8.52 1.623 11.769 4.93 6.436 6.615 6.436 17.348-.061 23.962"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_1196_34592"
          x1="67.269"
          x2="128.769"
          y1="52.5"
          y2="128"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1D9E6"></stop>
          <stop
            offset="1"
            stopColor="#96A1AD"
          ></stop>
        </linearGradient>
        <filter
          id="filter0_d_1196_34592"
          width="142.447"
          height="145.671"
          x="0"
          y="1.665"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood
            floodOpacity="0"
            result="BackgroundImageFix"
          ></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="11"></feOffset>
          <feGaussianBlur stdDeviation="11"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1196_34592"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1196_34592"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
};
